import type { RailBranch } from "@/data/rail-branches";
import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import type { ChapterBoard } from "../ChapterBoard/types";

export interface GpuSceneStart {
  startMs: number;
  locationLabel: string;
}

export interface TimelineGpuScene {
  totalDurationMs: number;
  branches: readonly RailBranch[];
  sceneStarts: readonly GpuSceneStart[];
}

export function timelineGpuSceneFromBoard(board: ChapterBoard): TimelineGpuScene {
  return {
    totalDurationMs: board.totalDurationMs,
    branches: board.rail.branches,
    sceneStarts: sceneStartsFromBeats(board.beats),
  };
}

export function timelineGpuSceneFromLayout(
  layout: BookTimelineLayout,
): TimelineGpuScene {
  return {
    totalDurationMs: layout.totalDurationMs,
    branches: layout.rail.branches,
    sceneStarts: sceneStartsFromBeats(layout.beats),
  };
}

function sceneStartsFromBeats(
  beats: readonly { startMs: number; locationLabel: string }[],
): GpuSceneStart[] {
  const seen = new Set<string>();
  const starts: GpuSceneStart[] = [];
  for (const beat of beats) {
    const key = `${beat.startMs}:${beat.locationLabel}`;
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    starts.push({
      startMs: beat.startMs,
      locationLabel: beat.locationLabel,
    });
  }
  return starts;
}
